import MessageLayout from '@components/MessageLayout';
import { APP_URL, USE_BLS_THEME } from '@constants';
import { useRegisterContext } from '@contexts/RegisterProvider';
import { Button, Icon } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { resolveUrl } from '~/utils/urlUtils';

export default function RegistrationSuccess() {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { registrationCode, reset } = useRegisterContext();

  useEffect(() => {
    reset();
    queryClient.clear();
  }, [queryClient, reset]);

  return (
    <MessageLayout
      icon={
        <Icon sx={{ fontSize: 32 }}>
          <img src="/icons/check.svg" alt="Green Check" draggable={false} />
        </Icon>
      }
      title={t('registrationComplete.title')}
      text={t(`registrationComplete.${registrationCode?.length !== 12 ? 'autoApproveMessage' : 'manualApproveMessage'}`, {
        app: USE_BLS_THEME ? 'Bikeleasing' : 'Probonio',
      })}
      actions={
        <Button data-test-id="button-complete-registration" href={resolveUrl(APP_URL)}>
          {t('registrationComplete.login')}
        </Button>
      }
    />
  );
}
